<template>
  <div class="commonBottom">
    <div class="descPart">
      <div class="textPart">
        <p style="margin-left: 240px;">南数集团</p>
        <p style="margin-left: 24px;">江苏前沿交叉计算技术研究院</p>
        <p>软件数字化工厂开启数字化变革</p>
      </div>
    </div>
   <div class="connectPart">
    <div class="leftPart">
      <div>
        <el-image :src="bottomLogo"></el-image>
      </div>
      <div>
        <el-image :src="botLogoImg"></el-image>
        <div>江苏前沿交叉计算技术研究院</div>
      </div>
      <div>
        <span class="lightColor">全国服务电话</span>
        <span>025-86959565</span>
        <span class="lightColor lightColor2">地址</span>
        <span>江苏省南京市栖霞区南京大学国家大学科技园9号楼</span>
      </div>
      <div class="line"></div>
      <div>
        <span>南京南数数字产业集团有限公司版权所有</span>
        <a href="" @click="toLink">备案证书 苏ICP备2024119271号-1</a>
      </div>
    </div>
    <div class="rightPart">
      <div>
        <img :src="nanshuImg" alt="" style="width: 128px;height: 128px;border-radius: 5px;">
        <div>南数集团</div>
      </div>
      <div style="margin-left: 20px;">
        <img :src="ewmImg" alt="">
        <div>前沿交叉研究院</div>
      </div>
    </div>
   </div>
  </div>
</template>

<script>

export default {
  name: "commonBottom",
  data() {
    return {
      bottomLogo:require('@/assets/img/common/bottomLogo2.png'),
      botLogoImg:require('@/assets/img/common/botLogo.png'),
      nanshuImg:require('@/assets/img/common/nanshu.jpg'),
      ewmImg:require('@/assets/img/common/ewm.png')
    }
  },
  methods: {
    toLink() {
      window.open('https://beian.miit.gov.cn/#/Integrated/index');
    }
  },
  mounted() {

  },
}
</script>

<style  lang="scss" scoped>
.commonBottom{
  .descPart{
    height:415px;
    background:url('../../assets/img/common/botBg.png') no-repeat;
    background-size:100% 100%;
    position:relative;
    .textPart{
      position: absolute;
      left:230px;
      top:72px;
      color:#fff;
      font-size:48px;
      font-weight:bold;
      >p{
        line-height: 20px;
      }
    }
  }
  .connectPart{
    display: flex;
    justify-content: center;
    align-items: center;
    background:#161616;
    color:#f3f3f3;
    padding:38px 0 25px 0;
    .leftPart{
      margin-right:127px;
      >div{
        &:first-child{
          display: inline-block;
          .el-image{
            width:183px;
            height:44px;
          }
        }
        &:nth-child(2){
          display: inline-block;
          font-size:12px;
          margin-left: 34px;
          margin-bottom:40px;
          .el-image{
            width:97px;
            height:58px;
            position: relative;
            top: 15px;
          }
        }
        &:nth-child(3){
          .lightColor{
            color:#00A3FE;
            margin-right:8px;
          }
          .lightColor2{
            margin-left:40px;
          }
        }
        &:nth-child(4){
          width:946px;
          height:1px;
          background:#F3F3F3;
          margin:23px 0 10px 0;
        }
        &:last-child{
          a{
            color:#F3F3F3;
            margin-left:10px;
          }
        }
      }
    }
    .rightPart{
      display: flex;
      text-align: center;
      img{
        width:129px;
        height:129px;
        margin-bottom:10px;
      }
    }
  }

}

</style>
